import { ThingPersisted } from '@inrupt/solid-client'
import { URI } from '../utils/ontology'
import { SurveyElement } from './SurveyElement'
import { checkType } from './utils'

export class Question extends SurveyElement {
  constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_SINGLE_INPUT_QUESTION_CLASS)
    super(thing)
  }
}
